import { PunkParsedGameData } from "../../../server/data/PunkParsedGameData";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SoundConfig } from "../../../SoundConfig";
import { ReelEngineEvent } from "@nolimitcity/slot-game/bin/core/engines/reel/event/ReelEngineEvent";
import { ReelSlicedDivider } from "../../independent/divider/ReelSlicedDivider";
import { ReelAnimationState } from "../../independent/reelAnimator/ReelAnimationController";
import { Container } from "pixi.js";
import { AnimationEffects } from "../../../effects/AnimationEffects";
import { Power3, TweenLite, TimelineMax, TweenMax } from "gsap";
import { ReelAnimationManager } from "../../independent/reelAnimator/ReelAnimationManager";
import { PunkBackground } from "../../../background/PunkBackground";
import { ReelState } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { IStickyJump, IMysteryData } from "../../../server/data/PunkServerData";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { TimeCheckPoints } from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { ReelItemOverlay, ReelOverlayState } from "../../independent/overlay/ReelItemOverlay";
import { StateSymbolWin } from "../../independent/symbol/StateSymbolWin";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { JumpingWildController } from "../../independent/jumpingWild/JumpingWildController";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { PunkEngineController } from "../../../punkEngine/PunkEngineController";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { ReelSymbolSize } from "../../../punkEngine/config/PunkSymbolData";
import { PunkSymbol } from "../../../punkEngine/PunkSymbol";
import { IExpandAnimateConfig } from "../../../punkEngine/PunkEnginePlayer";

export class ReelStopPresentation extends Presentation {

    protected _gameData: PunkParsedGameData | undefined;
    protected isNormal: boolean = false;
    protected nextIsFeature: boolean = false;

    protected shake: boolean = true;
    protected _amountOfScatterLands: number = 0;

    protected attentionPlays: boolean = false;
    protected _scatterPositions:number[];

    protected _nearWinLength:number = 0;
    protected _nearWinSymPos:number[][] =[];
    protected _possibleWinSymbols:string[][] =[];

    protected _mystData: IMysteryData;
    protected _expandingMultiplyValues:number[];

    protected _jumpPositions:IStickyJump[];
    protected _totalScatterLands:number = 0;

    protected wildLandPos: number[];
    protected _lockedReelPositions:boolean[];

    protected reelHightMaximus:number = 3;

    protected isBigWin:boolean = false;
    protected isBigPlay:boolean = false;

    protected _animationTimeline:TimelineMax;

    public addEventListeners() {
        EventHandler.addEventListener(this, ReelEngineEvent.REEL_STOP_COMPLETED, (event: GameEvent) => this.playStopAnimation(event.params[0]));
        EventHandler.addEventListener(this, ReelEngineEvent.REEL_STOP_SPIN_BOUNCE_STARTED, (event: GameEvent) => this.playBounceAnimation(event.params[0]));
    }

    public checkForActivation(data: PunkParsedGameData): boolean {
        return data.mode == GameMode.NORMAL;
    }

    public isActive():boolean{
        return (PunkEngineManager.isPlaying && !!this._gameData) && super.isActive();
    }

    public setParsedGamedData(data: PunkParsedGameData): void {
        if(this._gameData) return;
        this._animationTimeline = new TimelineMax();

        this._gameData = data;
        this.isNormal = data.mode === GameMode.NORMAL;
        this.wildLandPos = data.wildLandPositions;
        this._amountOfScatterLands = 0;
        this._scatterPositions = data.scatterReelPositions;
        this._jumpPositions = data.stickyJumpPositions;

        this._mystData = data.mysteryData!;

        let mysteryBigWinBlock:boolean = this._gameData.allWinData.symbols.indexOf(this._mystData.mysterySymbolRevealed) >= 0;
        for(let m:number = 0; m < 3; m++){
            if(this._mystData.mysterySymbolOnReel[m]) mysteryBigWinBlock = true;
        }

        if(!mysteryBigWinBlock) mysteryBigWinBlock = data.allWinData.longest <= 3;

        this.isBigWin = data.isBigWin && !mysteryBigWinBlock && data.scatterLandAmount < 2;
        if(this.isBigWin) this.isBigPlay = true;

        this.nextIsFeature = data.nextMode !== GameMode.NORMAL && data.mode === GameMode.NORMAL;
        this._nearWinSymPos = this.createNearWinMap(data);

        this._totalScatterLands = data.scatterLandAmount;
        this._expandingMultiplyValues = data.expandingMultiplyValues;

        this._lockedReelPositions = ArrayHelper.initArrayWithValues(PunkEngineManager.AllReels.length, () => false);
        PunkEngineManager.AllReels.forEach(reel => { if(!reel.isActive) this._lockedReelPositions[reel.reelID] = true;});
    }

    public getPresentation(): void {
        if(!this.isActive()){
            if(this._animationTimeline.isActive()) this.pTimeline.to(this,this._animationTimeline.totalDuration() - this._animationTimeline.totalTime(),{});
            return;
        }
        if(this.reelHightMaximus == 6) PunkEngineManager.RAll((reelID:number) => PunkEngineManager.getReel(reelID).isQuickStop = false);

        if(PunkEngineManager.isQuickStop){
            TweenMax.globalTimeScale(3);
            for(let reel:number = 0; reel < PunkEngineManager.AllReels.length; reel++){
                for(let r:number = 0; r < PunkEngineManager.getReel(reel).windowAmount;r++){
                    let symPos:number = PunkEngineManager.getReel(reel).AllWindowSymbols[r].posID;
                    PunkEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(0 , 0.2);
                }
            }
        }
        if (PunkEngineManager.findFirstReelWithState(ReelState.STEP) >= 0)
            this.normalStop();
        else{
            this.pTimeline.to(this,0.1,{});
        }
    }

    protected normalStop(delays: number[] = this.calculateStopDelays()):void{
        if(this.isBigWin && !PunkEngineManager.isQuickStop)
            delays = this.bigModifier(delays);
        else if(this.reelHightMaximus == 6)
            delays = this.megaReelModifier(delays);
        else
            delays = this.normalDelayModifier(delays);

        const addDelay: number = delays[delays.length - 1];
        const animationDelay:number = this._animationTimeline.isActive() ? (this._animationTimeline.totalDuration() - this._animationTimeline.totalTime()) * 0.5: 0;
        for(let i:number = 0; i < delays.length-1;i++) delays[i] += animationDelay;
        
        let combinedTotal:number  = Math.max(...delays) + addDelay ;
        const timeStop:number = (GameSetting.isFastSpin || PunkEngineManager.isQuickStop ? 2 : 3) + MathHelper.frameToSeconds(1);

        // if(TimeCheckPoints.getCheckPointTime("Bet")/1000 + combinedTotal < timeStop && this.isNormal){
        //     if(!PunkEngineManager.isQuickStop){
        //         const delayAdd:number = timeStop - (TimeCheckPoints.getCheckPointTime("Bet")/1000  + (combinedTotal));
        //         for(let i:number = 0; i < delays.length-1;i++) delays[i] += Power3.easeOut.getRatio(i/5)* (delayAdd);
        //     }
        // }

        combinedTotal  = Math.max(...delays) + addDelay;
        this.pTimeline.add(() => {}, PunkEngineManager.stopReels(delays) );
        // for (let reel = 0; reel < delays.length - 1; reel++) this.pTimeline.add(() => PunkEngineManager.AllReels[reel].stopSpin(), delays[reel]);
    }

    private megaReelModifier(delays: number[]):number[]{
        let delay: number = 0;
        const nervDelay:number = 0.35;
        for(let reel = 0; reel < PunkEngineManager.AllReels.length; reel++) {
            if(delays[reel] == 0 || !PunkEngineManager.getReel(reel).visible) continue;
            delays[reel] += delay;
            // Mystery
            if(this._nearWinLength >= reel)
                delay += nervDelay;
            else
                delay += nervDelay*0.5;
        }
        return delays;
    }

    private bigModifier(delays: number[]):number[]{
        const nervDelay:number = 2.5;
        let delay:number = 0;
        for(let reel = 0; reel < PunkEngineManager.AllReels.length; reel++) {
            if(delays[reel] == 0 || !PunkEngineManager.getReel(reel).visible) continue;

            if(this._nearWinLength >= reel && reel > 3){
                if(this._gameData?.mode == GameMode.RESPIN && this.wildLandPos[reel] >= 0){
                    delay += nervDelay/2;
                    delays[reel] += delay;
                    continue;
                }
                else
                    delay += nervDelay

                if(this.wildLandPos[reel] >= 0)
                    delay += this.wildTotalLandDuration(reel) * (reel > 3 ? 2: 1);
            }
            
            delays[reel] += delay
        }
        return delays;
    }

    private normalDelayModifier(delays: number[]):number[]{
        let delay: number = 0;
        let delayAttentionCounter: number = -1;
        if (PunkEngineManager.isQuickStop) return delays;
        for(let reel = 0; reel < PunkEngineManager.AllReels.length; reel++) {
            if(delays[reel] == 0 || !PunkEngineManager.getReel(reel).visible) continue;
            delays[reel] += delay;
            if (!PunkEngineManager.getReel(reel).isActive || PunkEngineManager.getReel(reel).state.isIdle){
                continue;
            } 
            // Scatters/Bonus
            if(this._scatterPositions[reel] >= 0 || delayAttentionCounter >= 0) {
                if(this._scatterPositions[reel] >= 0) delayAttentionCounter++;
                delayAttentionCounter = Math.min(delayAttentionCounter,1);
                delay += 0.5 +  delayAttentionCounter * 2.8;
            } 
            else{
                // Wilds    
                if(this.wildLandPos[reel] >= 0)// && this._nearWinLength >= reel)
                    delay += this.wildTotalLandDuration(reel);
                // Mystery    
                if(this._mystData.mysterySymbolOnReel[reel] )
                    delay += 0.6;
            }
        }

        return delays;
    }

    // Prolonged-PossibleWin Stop Calculation
    protected calculateStopDelays(): number[] {
        let delays: number[] = [];

        for (let i = 0; i < PunkEngineManager.AllReels.length; i++) { PunkEngineManager.AllReels[i].createStop();}

        let delay: number = 0.01;
        let lastStopTime: number = 0;

        for (let reel = 0; reel < PunkEngineManager.AllReels.length; reel++) {
            const rc:PunkEngineController = PunkEngineManager.getReel(reel);

            // Activate the next animation
            if (!rc.isActive || rc.state.isIdle) {
                delays.push(0);
                continue;
            }

            if(reel == 0 && !PunkEngineManager.isQuickStop){
                // delay += rc.getPlayTime();
                delays.push(0);
                continue;
            }

            delay += rc.getStopDelay();
            delay += rc.state.isSpinning ? rc.getPlayTime() : PunkGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.SPIN;
            if(this._scatterPositions[reel] >= 0 && PunkEngineManager.isQuickStop)
                delay +=  PunkGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.QUICK_STOP;
            delays.push(delay);
            lastStopTime = rc.getNextAnimationTime();
            lastStopTime = lastStopTime === 0 ? rc.getPlayTime() : lastStopTime;
        }

        // delays.push(lastStopTime);
        return delays;
    }

    private playSound(name:string, repeat?:number):void{
        if(!PunkEngineManager.isQuickStop) SoundManager.playSoundEffect(name,repeat);
    }

    protected playBounceAnimation(reelID: number): void {
        if (this._gameData == undefined) return;
        
        ReelSlicedDivider.instance.addDividers(true,reelID);
        if(PunkEngineManager.isQuickStop && reelID == 4)
            SoundManager.playSoundEffect(SoundConfig.instance.REELS_DEFAULT_STOP[reelID])
        else
            this.playSound(SoundConfig.instance.REELS_DEFAULT_STOP[reelID]);

        if(reelID > 2 && this.isBigWin) this.bigWinAnimation(reelID);
        this.scatterBehaviour(reelID);
        this.nearWinBehaviour(reelID);

        if(this._mystData.mysterySymbolOnReel[reelID])
            this.playSound(this._nearWinLength >= reelID ? SoundConfig.instance.XWAYS_LAND : SoundConfig.instance.XWAYS_LAND_DEAD);
        
        // look if the next reel is an locked/Idle state.
        if(PunkEngineManager.getNextReelID(reelID) != -1){
            let nextReelPosID:number = PunkEngineManager.getNextReelID(reelID);
            while (PunkEngineManager.getReel(nextReelPosID).visible && PunkEngineManager.getReel(nextReelPosID).state.equal(ReelState.IDLE)) {
                this.nearWinBehaviour(nextReelPosID);
                if(nextReelPosID > 2 && this.isBigWin) this.bigWinAnimation(nextReelPosID);
                    nextReelPosID++;
                if(PunkEngineManager.getNextReelID(nextReelPosID) == -1) break;
            }
        }

        if ((this.isNormal && reelID == 4) || (!this.isNormal && reelID == 5) ) {
            if (this._amountOfScatterLands > 1 && this.attentionPlays) {
                this.playSound(SoundConfig.instance.ANTICIPATION_END);
                SoundManager.stopSoundEffect(SoundConfig.instance.ANTICIPATION_START);
            }
            SoundManager.stopSoundEffect(SoundConfig.instance.REELS_SPINNING);
            this.PresentationState.set(PresentationState.INACTIVE);
        }
        this.bounceWild(reelID);
    }

    protected bigWinAnimationStop(reelID: number):void{
        const stopreel:number = this.isNormal ? 4 : 5;
        if(reelID != stopreel) return;
    }

    protected bigWinAnimation(reelID: number): void {
        let playDuration:number = this._animationTimeline.totalTime();
        const lightDuration:number = 0.35;
        const lightDurationDelay:number = lightDuration*0.4;

        const stopreel:number = this.isNormal ? 4 : 5;
        if(!this._lockedReelPositions[reelID]) ReelAnimationManager.getReelArea(reelID).killLoop();
        const alpha:number = reelID != stopreel ? 0.6 : 0;
        for(let i = reelID; i >= 0; i--){
            for(let r:number = 0; r < PunkEngineManager.getReel(i).windowAmount;r++){
                let symPos:number = PunkEngineManager.getReel(i).AllWindowSymbols[r].posID;
                if(!this._gameData?.allWinData.reelWinPositions[i][symPos]){
                    symPos -= PunkEngineManager.getReel(i).state.isIdle ? 0 : 1;
                    PunkEngineManager.getReel(i).getSymbol(symPos)!.attentionDarkness(alpha,0.2);
                }
            }
        }
        if(reelID == stopreel){
            SoundManager.stopSoundEffect(SoundConfig.instance.ANTICIPATION_BIG);
            SoundManager.playSoundEffect(SoundConfig.instance.ANTICIPATION_PLING);            
            SoundManager.playSoundEffect(SoundConfig.instance.EXPANDING_PLING);
            for(let i = 0; i <= reelID; i++){
                for(let r:number = 0; r < PunkEngineManager.getReel(i).windowAmount;r++){
                    let symPos:number = PunkEngineManager.getReel(i).AllWindowSymbols[r].posID;
                    if(this._gameData?.allWinData.reelWinPositions[i][symPos]){
                        this._animationTimeline.add(() => ReelItemOverlay.instance.lightPosition(i, symPos, lightDuration/2, 0.6 ), playDuration);
                        this._animationTimeline.add(() => ReelItemOverlay.instance.nearWinSpot(i, symPos, lightDuration, false), playDuration+lightDuration/2);
                    }
                }
            }
            this._animationTimeline.to(this,lightDuration,{})
            return;
        }

        if (PunkEngineManager.isQuickStop) return;

        this.blackScreenShake(reelID);
        if(this.isBigPlay){
            this.isBigPlay = false;
            SoundManager.playSoundEffect(SoundConfig.instance.ANTICIPATION_BIG);
            SoundManager.fadeAmbienceLoop(0,350);
        }

        if(reelID != stopreel && this._nearWinLength > reelID){
            if(!this._lockedReelPositions[reelID + 1])
                ReelAnimationManager.getReelArea(reelID + 1).activateLoop(ReelAnimationState.FIRE, MathHelper.frameToSeconds(6),true);
            for(let repeat:number = 0; repeat < reelID; repeat++){
                for(let i = 0; i <= reelID; i++){
                    for(let r:number = 0; r < PunkEngineManager.getReel(i).windowAmount;r++){
                        let symPos:number = PunkEngineManager.getReel(i).AllWindowSymbols[r].posID;
                        if(this._gameData?.allWinData.reelWinPositions[i][symPos]){
                            this._animationTimeline.add(() => ReelItemOverlay.instance.lightPosition(i, symPos, lightDuration , 0.6 ), playDuration + i*lightDurationDelay);
                            this._animationTimeline.add(() => ReelItemOverlay.instance.nearWinSpot(i, symPos, lightDuration, false), (playDuration+lightDuration/2) + i*lightDurationDelay);
                        }
                    }
                }
                this._animationTimeline.add(() =>  SoundManager.playSoundEffect(SoundConfig.instance.BETLINE_HIGHTLIGHT_TINY), playDuration);
                playDuration += (reelID-1)*lightDurationDelay + lightDuration*0.5;
            }
        }
    }

    protected playStopAnimation(reelID: number): void {
        if (this._gameData == undefined) return;
        this.mysteryLandBehaviour(reelID);
        this.wildLandBehaviour(reelID);
        this.bigWinAnimationStop(reelID);
    }

    protected wildTotalLandDuration(reelID:number):number{
        const nonWin:boolean = this._nearWinLength < reelID;
        const transformDurr:number = nonWin ? MathHelper.frameToSeconds(8) : MathHelper.frameToSeconds(10);
        const growDelay:number = nonWin ? MathHelper.frameToSeconds(8) : MathHelper.frameToSeconds(10);
        const totalDurr:number = transformDurr + growDelay*(this.wildLandPos[reelID]);
        return totalDurr > 0 ? totalDurr : 0;
    }

    protected bounceWild(reelID:number):void{
        if(this.wildLandPos[reelID] == -1) return;

        let transformDurr:number = MathHelper.frameToSeconds(10);
        for(let row:number = 0; row < PunkEngineManager.getReel(reelID).windowAmount; row++){
            if(!PunkEngineManager.getReel(reelID).AllWindowSymbols[row].isWild) continue;
            PunkEngineManager.getReel(reelID).getSymbol(row)!.changeState({
                state: ReelSymbolStates.LANDING,
                forceState:true,
                newSym:ReelSymbolName.WILD,
                duration: transformDurr
            })
            ReelItemOverlay.instance.playAnimation(reelID,this.wildLandPos[reelID],ReelOverlayState.FIRE,transformDurr);
        }

        this.playSound(SoundConfig.instance.WILD_LAND);
    }

    protected wildLandBehaviour(reelID:number):void{

        let transformDurr:number = MathHelper.frameToSeconds(10);
        let growDelay:number = MathHelper.frameToSeconds(10);
        const reelIsQuickstopping:boolean = PunkEngineManager.getReel(reelID).state.lastState === ReelState.QUICK_STOP;
        if(this.wildLandPos[reelID] == -1 || reelIsQuickstopping) return;

        let startTime: number = this._animationTimeline.totalTime();
        startTime *= PunkEngineManager.isQuickStop ? 2 : 1;

        let soundCount:number = 0;
        let transformed:boolean = false;
        for (let row: number = this.wildLandPos[reelID]-1; row >= 0; row--) {
            if(PunkEngineManager.getReel(reelID).getSymbol(row)!.isWild) continue;
            transformed = true;
            this._animationTimeline.add(PunkEngineManager.getReel(reelID).getSymbol(row)!.changeState({
                state: ReelSymbolStates.TRANSFORM,
                forceState:true,
                newSym:ReelSymbolName.WILD,
                duration: transformDurr
            }),startTime);
            this._animationTimeline.add(() => PunkEngineManager.getReel(reelID).getSymbol(row)!.attentionDarkness(0,transformDurr),startTime)
            this._animationTimeline.add(() => ReelItemOverlay.instance.playAnimation(reelID,row+1,ReelOverlayState.IGNITE,transformDurr),startTime-MathHelper.frameToSeconds(5));
            this._animationTimeline.add(() => ReelItemOverlay.instance.playAnimation(reelID,row,ReelOverlayState.FIRE,transformDurr),startTime);
            const soundType:string = soundCount == 0 ? SoundConfig.instance.WILD_EXPANDS_1 :SoundConfig.instance.WILD_EXPANDS_2;
            this._animationTimeline.add(() => this.playSound(soundType),startTime);
            this._animationTimeline.add(() => SoundManager.onFadeSoundEffect(soundType,  1 ,0),startTime);
            startTime += growDelay;
            soundCount++;
        }
        if(transformed)this._animationTimeline.to(this,transformDurr*0.5,{});
    }

    protected mysteryLandBehaviour(reelID: number): void {

        if(!this._mystData.mysterySymbolOnReel[reelID]) return;

        const expandTime:number = 0.3;
        const expandConfig: IExpandAnimateConfig = {
            toSize: ReelSymbolSize.FOUR + (this._mystData.mysterySymbolSize[reelID] - 1),
            reelID: [reelID],
            symbolID: this._mystData.mysterySymbolPositions[reelID],
            duration: expandTime
        }

        PunkEngineManager.onExpandSymbol(expandConfig);

        let size: number = expandConfig.toSize - ReelSymbolSize.FOUR;
        let sizeCounter: string = (size + 1).toString();
        
        StateSymbolWin.instance.playMultiplyAnimation({
            value: sizeCounter,
            ReelID: reelID,
            SymID: expandConfig.symbolID!,
            duration: expandTime,
            State: ReelSymbolStates.NORMAL,
        });

        ReelSlicedDivider.instance.changeSizeBg(reelID, expandTime);
        PunkGameModuleConfig.xWayCounter.setValue(undefined, this._expandingMultiplyValues[reelID], expandTime);
        for (let row: number = 0; row < PunkEngineManager.getReel(reelID).windowAmount; row++) {
            PunkEngineManager.getReel(reelID).getSymbol(row)!.changeSizeBg(expandTime);
            ReelItemOverlay.instance.changeSizeBg(reelID,row,expandTime);
        }

        for (let jw: number = 0; jw < this._jumpPositions.length; jw++){
            const itemReelID:number = JumpingWildController.instance.getExistingItem(jw)!.ReelID;
            if(itemReelID === reelID)
                JumpingWildController.instance.updateSymbolPositions(JumpingWildController.instance.getExistingItem(jw)! ,expandTime);
        }
        
        this._animationTimeline.to(this,expandTime,{});
    }

    protected nearWinBehaviour(reelID:number):void{
        if(this.isBigWin) return;

        const wPos:number[] = this.wildLandPos;
        const darkIntensity:number = this.isNormal ? 0.3 : 0.6;
        const jwPos:IStickyJump[] = this._jumpPositions;

        if(PunkEngineManager.isQuickStop){
            for(let reel:number = 0; reel <= reelID; reel++){
                for(let j:number = 0; j < PunkEngineManager.getReel(reel).windowAmount;j++){
                    let symPos:number = PunkEngineManager.getReel(reel).AllWindowSymbols[j].posID +  PunkEngineManager.getReel(reel).statePosOffset;
                    PunkEngineManager.getReel(reel).getSymbol(symPos)!.setActive(true,0,darkIntensity);
                }
            }
            return;
        }else if(this._nearWinLength > 2 && reelID >= 2){
            // Backward connection
            if(reelID == 2){
                for(let i:number = 0; i < this._possibleWinSymbols[reelID].length;i++){
                    for(let reel:number = reelID; reel >= 0; reel--){
                        const reelC:PunkEngineController = PunkEngineManager.getReel(reel);
                        for(let row:number = 0; row < reelC.windowAmount;row++){
                            let symPos:number = reelC.AllWindowSymbols[row].posID + reelC.statePosOffset;

                            const symbol:PunkSymbol = reelC.getSymbol(symPos)!;
                            const symbolHit:boolean = this._possibleWinSymbols[reelID].indexOf(symbol.symName) >= 0;

                            if(!nonLightCheck(reel,row) && lightPossibleSymbol(reelID,symPos)) continue;

                            if(symbolHit){
                                ReelItemOverlay.instance.nearWinSpot(reel, row ,0.25, true, 0.1);
                            }else{
                                symbol.setActive(false,0.1,darkIntensity);
                                ReelItemOverlay.instance.nearWinSpot(reel, row, 0.25,false,0.1);
                            }
                        }
                    }
                }
            }
            else if(this._possibleWinSymbols[reelID] != undefined){ // Current connection
                const reelC:PunkEngineController = PunkEngineManager.getReel(reelID);
                for(let i:number = 0; i < this._possibleWinSymbols[reelID].length;i++){
                    for(let j:number = 0; j < reelC.windowAmount;j++){
                        let symPos:number = reelC.AllWindowSymbols[j].posID + reelC.statePosOffset;
                        const symbol:PunkSymbol = reelC.getSymbol(symPos)!; 
                        const symbolHit:boolean = this._possibleWinSymbols[reelID].indexOf(symbol.symName) >= 0;
                        if(!nonLightCheck(reelID,j) && lightPossibleSymbol(reelID,symPos)) continue;
                        if(symbolHit){
                            ReelItemOverlay.instance.nearWinSpot(reelID, j ,0.25, true, 0.1);
                        }else{
                            symbol.setActive(false,0.1,darkIntensity);
                            ReelItemOverlay.instance.nearWinSpot(reelID, j, 0.25,false,0.1);
                        }
                    }
                }
            }else{
                for(let j:number = 0; j < PunkEngineManager.getReel(reelID).windowAmount;j++){
                    let symPos:number = PunkEngineManager.getReel(reelID).AllWindowSymbols[j].posID + PunkEngineManager.getReel(reelID).statePosOffset;
                    const symbol:PunkSymbol = PunkEngineManager.getReel(reelID).getSymbol(symPos)!; 
                    if(nonLightCheck(reelID,j) && lightPossibleSymbol(reelID,symPos)) symbol.setActive(false,0.1,darkIntensity);
                    ReelItemOverlay.instance.nearWinSpot(reelID, j, 0.25, false);
                }
            }
        }

        function lightPossibleSymbol(reel:number,sym:number){
            return PunkEngineManager.getReel(reel).getSymbol(sym)!.isNormalSym  && !PunkEngineManager.getReel(reel).getSymbol(sym)!.isInactive;
        }

        function nonLightCheck(reel:number,sym:number):boolean{
            // dont deactivate the symbol behind jumpingwild.
            if(jwPos.length > 0){
                for(let jw:number = 0; jw < jwPos.length; jw++){
                    if(jwPos[jw].to.x == reel && jwPos[jw].to.y == sym) return false;
                }
            }
            return wPos[reel] < sym;
        }
    }

    protected scatterBehaviour(reelID:number):void{
        if (!this.isNormal) return;

        let position: number = this._scatterPositions[reelID];
        if (this._amountOfScatterLands > 0) ReelAnimationManager.getReelArea(reelID).killLoop();

        if(position >= 0) position += PunkEngineManager.getReel(reelID).Engine.reverse ? 2 : 0;

        if (!(this._amountOfScatterLands == 0 && reelID == 4) && position >= 0 ) {
            this._amountOfScatterLands++;
            let scatterSound:string = SoundConfig.instance.SCATTER_LAND;
            if(this._amountOfScatterLands == 3){
                scatterSound = SoundConfig.instance.SCATTER_LAND2;
            }else if(this._amountOfScatterLands == 4)
                scatterSound = SoundConfig.instance.SCATTER_LAND3;

            PunkEngineManager.getReel(reelID).getSymbol(position-1)!.changeState({
                state: ReelSymbolStates.ATTENTION,
                repeat: -1,
            });

            this.blackScreenShake(this._amountOfScatterLands);
            if(this._amountOfScatterLands >= 2 && !PunkEngineManager.isQuickStop && this.isNormal){
                if(reelID != 4){
                    for(let i = reelID; i >= 0; i--){
                        for(let r:number = 0; r < PunkEngineManager.getReel(i).windowAmount;r++){
                            let symPos:number = PunkEngineManager.getReel(i).AllWindowSymbols[r].posID + PunkEngineManager.getReel(i).statePosOffset;
                            PunkEngineManager.getReel(i).getSymbol(symPos)!.attentionDarkness(0.6);
                        }
                    }
                }
            }
            SoundManager.playSoundEffect(scatterSound)
            ReelAnimationManager.bonusReel.NumberOfSkulls(this._amountOfScatterLands);
        }else{
            if(this._amountOfScatterLands >= 2 && reelID != 4 && !PunkEngineManager.isQuickStop){
                for(let r:number = 0; r < PunkEngineManager.getReel(reelID).windowAmount;r++){
                    let symPos:number = PunkEngineManager.getReel(reelID).AllWindowSymbols[r].posID;
                    PunkEngineManager.getReel(reelID).getSymbol(symPos)!.attentionDarkness(0.6);
                }
            }
            if(this.wildLandPos[reelID] >= 0 || position >= 0) this.miniShake();
        } 

        if (reelID != 4 && this._amountOfScatterLands > 1 && !PunkEngineManager.isQuickStop) {
            ReelAnimationManager.getReelArea(reelID + 1).activateLoop(ReelAnimationState.FIRE, MathHelper.frameToSeconds(6),true);
            ReelAnimationManager.getReelArea(reelID + 1).showAnimation(ReelAnimationState.SWEEP);
            if (this._amountOfScatterLands == 2 && !this.attentionPlays) {
                this.playSound(SoundConfig.instance.ANTICIPATION_START);
                SoundManager.bonusMusicBigWin(false);
                this.attentionPlays = true;
            } 
            if(this._amountOfScatterLands == 2 )
                PunkGameModuleConfig.xWayCounter.showCrazyMessage("!??!!!!???",2)
            else if(this._amountOfScatterLands == 3)
                PunkGameModuleConfig.xWayCounter.showCrazyMessage("!?!!??!!???!!?!!!!!!?!",3)
        }
        if(reelID == 4 && this._totalScatterLands >= 2){
            for(let reel:number = 0; reel < reelID; reel++){
                for(let r:number = 0; r < PunkEngineManager.getReel(reel).windowAmount;r++){
                    let symPos:number = PunkEngineManager.getReel(reel).AllWindowSymbols[r].posID;
                    PunkEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(0 , 0.2);//,this._animationTimeline.totalTime());
                }
            }
            this._animationTimeline.add(() => ReelAnimationManager.bonusReel.showAnimation(ReelAnimationState.NORMAL),this._animationTimeline.totalTime());

            if(this._gameData!.nextMode == GameMode.RESPIN){
                PunkBackground.instance.changeGraphicAlpha(0.2, 0.4);
            }else if(this.nextIsFeature){
                PunkBackground.instance.changeGraphicAlpha(0.2, 0.6);
            }
        }
    }

    protected miniShake(): void {
        if (!this.shake) return;
        const container: Container = StageManager.getLayer(PunkGameConfig.instance.LAYERS.REEL_OVERLAY.name).parent;
        AnimationEffects.Shake({
            x: .1,
            y: 0.6,
            duration: 0.15,
            hertz: 80,
            Intensity: 4,
            obj: container,
            positionCb: () => new PIXI.Point(0,0),
            ease: Power3.easeOut,
            reverseEase: true
        }).play();
    }

    protected blackScreenShake(powAmount:number): void {
        if (!this.shake) return;
        this.shake = false;
        let power: number = Math.min(powAmount, 4)
        const container: Container = StageManager.getLayer(PunkGameConfig.instance.LAYERS.REEL_OVERLAY.name).parent;
        AnimationEffects.Shake({
            x: .2,
            y: 1,
            duration: 0.5 + (power * 0.2),
            hertz: 180 + (power * 60),
            Intensity: 8 + (power * 6.5),
            obj: container,
            positionCb: () => new PIXI.Point(0,0),
            ease: Power3.easeOut,
            reverseEase: true
        }).play();
        
        if(power > 1)
        PunkBackground.instance.playAttentionBlackFlash(
                0.4,
                0.3 + (power * 0.1),
                0.4 + power * 0.1,
            ).play();

        // Reel
        TweenLite.to(this, 0.200, {}).eventCallback("onComplete", () => { this.shake = true })
    }

    protected createNearWinMap(data: PunkParsedGameData):number[][]{

        function fetchHitSymbols():string[][]{
            let arr:string[][] = [];
            for(let m:number = 0; m < map.length; m++){
                arr.push([]);
                for(let j:number = 0; j < map[m].length;j++){
                    const symTargetName:string = reelPosData[m][map[m][j]+1];
                    if(arr[m].indexOf(symTargetName) == -1){
                        arr[m].push(symTargetName);
                        if([ReelSymbolName.WILD, ReelSymbolName.MYSTERY].indexOf(symTargetName) >= 0 && m != 0){
                            arr[m] = arr[m].concat(arr[m-1]);
                        }
                    }
                }
                arr[m] = arr[m].filter((sym:string) => { return sym != ReelSymbolName.WILD && sym != ReelSymbolName.MYSTERY})
            }
            return arr;
        }

        const map:number[][] = data.nearWinMap;
        const reelPosData:string[][] = [];

        let maxWays:number = data.gameAreaSize[0];
        for(let k = 1; k < data.reels.length;k++){
            maxWays *= data.gameAreaSize[k];
        }

        this.reelHightMaximus = maxWays == Math.pow(6,6) && data.mode == GameMode.FREESPIN ? 6 : 3;

        for(let i = 0; i < data.reels.length;i++){
            reelPosData.push(Array.from(data.reels[i]));
        }
        
        for(let jumpPos:number = 0; jumpPos < this._jumpPositions.length; jumpPos++){
            const reel:number = this._jumpPositions[jumpPos].to.x;
            const row:number = this._jumpPositions[jumpPos].to.y+1;
            reelPosData[reel][row] = ReelSymbolName.WILD;
        }

        for(let wildReel:number = 0; wildReel < data.wildLandPositions.length; wildReel++){
            if(data.wildLandPositions[wildReel] == -1) continue;
            for(let row:number = data.wildLandPositions[wildReel]; row >= 0; row--){
                reelPosData[wildReel][row] = ReelSymbolName.WILD;
            }
        }
        
        this._nearWinLength = map.length;
        this._possibleWinSymbols = fetchHitSymbols();

        return map;
    }

    public promiseSync(): boolean {
        const animationRunning:boolean = this._animationTimeline && this._animationTimeline.isActive();
        const allReelsStopped:boolean = PunkEngineManager.getStoppingReel() == -1;

        return !animationRunning && allReelsStopped;
    }

    public stopPresentation(): void {

        PunkEngineManager.isPlaying = false;

        PunkEngineManager.updateNextActivated();

        SoundManager.stopSoundEffect(SoundConfig.instance.REELS_SPINNING);
        TweenMax.globalTimeScale(1);
        
        if(this._totalScatterLands > 2)
            SoundManager.fadeAmbienceLoop(0,0);

        ReelItemOverlay.instance.reelStopped = true;
        Logger.logDev(TimeCheckPoints.getCheckPointTime("Bet").toString());

        if(this._totalScatterLands == 1){
            ReelAnimationManager.bonusReel.removeSkulls();
            PunkEngineManager.RSWindow((reel:number,sym:number) => { PunkEngineManager.getReel(reel).getSymbol(sym)!.changeState({ state: ReelSymbolStates.IDLE });})
            PunkEngineManager.RAll((reel:number) => ReelAnimationManager.getReelArea(reel).killLoop());
        }

        this._amountOfScatterLands = 0;
        this.attentionPlays = false;
        this._gameData = undefined;
    }
}

